import { gql } from '@apollo/client';

// ── Query: lightweight meter lookup by meter number (for audit search confirmation) ──
export const METER_BY_NUMBER = gql`
  query MeterByNumber($meterNumber: String!) {
    meterByNumber(meterNumber: $meterNumber) {
      meterId
      meterNumber
      meterName
    }
  }
`;

// ── Query: fetch a single meter's core info ──────────────────────────────────
export const METER_CORE_INFO = gql`
  query MeterCoreInfo($meterId: Int!) {
    meterCoreInfo(meterId: $meterId) {
      meterId
      meterNumber
      meterName
      energy
      region
      statGl {
        glId
        glNumber
      }
      dollarGl {
        glId
        glNumber
      }
      ipp {
        ippId
        vendorName
        purchaseOrderNo
        needDetailsWithInvoice
      }
      meterFileSource
      kwhGenerated
      kwhUsed
      retroactiveReminder
      energyBid
      selectedRateId
      selectedRateType
      meterType
      piTagNameArgControlStatus
      piTagNameMegawattValue
      lossFactor
      multiplier
      poLineNumber
      operationalStatus
      operationalStatusDate
      applyHst
      adminFeeRate
      adminFeeGl {
        glId
        glNumber
      }
      forecastFee
      forecastFeeCurrency
      forecastFeeGl {
        glId
        glNumber
      }
      rateContracts {
        rateId
        meterId
        rateType
        effectiveFrom
        effectiveTo
        rate
        rateDescription
        isPlaceholder
      }
    }
  }
`;

// ── Query: look up an IPP record by vendor name ──────────────────────────────
// Used in CreateMeterPage to resolve ippId when user types a vendor name.
export const GET_IPP_BY_VENDOR_NAME = gql`
  query IppByVendorName($vendorName: String!) {
    ippByVendorName(vendorName: $vendorName) {
      ippId
      vendorName
      purchaseOrderNo
    }
  }
`;

// ── Mutation: create a new meter ─────────────────────────────────────────────
export const CREATE_METER_CORE_INFO = gql`
  mutation CreateMeterCoreInfo($input: CreateMeterCoreInput!) {
    createMeterCoreInfo(input: $input) {
      meterId
      meterNumber
      meterName
      energy
      region
      meterType
      meterFileSource
      kwhGenerated
      kwhUsed
      energyBid
      piTagNameArgControlStatus
      piTagNameMegawattValue
      lossFactor
      multiplier
      poLineNumber
      operationalStatus
      operationalStatusDate
      applyHst
      adminFeeRate
      adminFeeGl {
        glId
        glNumber
      }
      forecastFee
      forecastFeeCurrency
      forecastFeeGl {
        glId
        glNumber
      }
      selectedRateType
      selectedRateId
      rateContracts {
        rateId
        meterId
        rateType
        effectiveFrom
        effectiveTo
        rate
        rateDescription
        isPlaceholder
      }
      ipp {
        ippId
        vendorName
        purchaseOrderNo
        needDetailsWithInvoice
      }
      statGl {
        glId
        glNumber
      }
      dollarGl {
        glId
        glNumber
      }
    }
  }
`;

// ── Mutation: update an existing meter ───────────────────────────────────────
export const UPDATE_METER_CORE_INFO = gql`
  mutation UpdateMeterCoreInfo($input: UpdateMeterCoreInput!) {
    updateMeterCoreInfo(input: $input) {
      meterId
      meterNumber
      meterName
      energy
      region
      statGl {
        glId
        glNumber
      }
      dollarGl {
        glId
        glNumber
      }
      ipp {
        ippId
        vendorName
        purchaseOrderNo
        needDetailsWithInvoice
      }
      meterFileSource
      kwhGenerated
      kwhUsed
      retroactiveReminder
      energyBid
      selectedRateId
      selectedRateType
      meterType
      piTagNameArgControlStatus
      piTagNameMegawattValue
      lossFactor
      multiplier
      poLineNumber
      operationalStatus
      operationalStatusDate
      applyHst
      adminFeeRate
      adminFeeGl {
        glId
        glNumber
      }
      forecastFee
      forecastFeeCurrency
      forecastFeeGl {
        glId
        glNumber
      }
      rateContracts {
        rateId
        meterId
        rateType
        effectiveFrom
        effectiveTo
        rate
        rateDescription
        isPlaceholder
      }
    }
  }
`;
export const METER_LATEST_READ_TYPE = gql`
  query MeterLatestReadType($meterId: Int!) {
    meterLatestReadType(meterId: $meterId)
  }
`;